export const validMobile = (value) => { // 手机号码
	return /^1\d{10}$/.test(value);
}

export const validTel = (value) => { // 座机号码
	return /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/.test(value);
}

export const validPhone = (value) => { // 座机或手机号码
	return value && value.charAt(0) == '1' ? validMobile(value) : validTel(value);
}

export const validIdCard = (value) => { // 身份证验证
	return /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(value);
}